import { render, staticRenderFns } from "./alert-dialog.vue?vue&type=template&id=635b8cfb"
import script from "./alert-dialog.vue?vue&type=script&lang=js"
export * from "./alert-dialog.vue?vue&type=script&lang=js"
import style0 from "./alert-dialog.vue?vue&type=style&index=0&id=635b8cfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports